/* tslint:disable */

declare var Object: any;
export interface LeaveSetupInterface {
  "id"?: number;
}

export class LeaveSetup implements LeaveSetupInterface {
  "id": number;
  constructor(data?: LeaveSetupInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LeaveSetup`.
   */
  public static getModelName() {
    return "LeaveSetup";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LeaveSetup for dynamic purposes.
  **/
  public static factory(data: LeaveSetupInterface): LeaveSetup{
    return new LeaveSetup(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LeaveSetup',
      plural: 'LeaveSetups',
      path: 'LeaveSetups',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/LeaveSetup.ts